if (!customElements.get('video-section')) {

  class VideoSection extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll('button.video-sound-btn')

      this.buttons.forEach(btn => btn.addEventListener('click', this.toggleSound.bind(this)));
    }

    toggleSound(e) {
      e.preventDefault();

      // toggle video muted attribute
      let video = e.currentTarget.nextElementSibling
      video.muted = !video.muted

      let buttons = this.buttons
      e.currentTarget.classList.toggle('sound-on')

      buttons.forEach((btn) => {
        if (btn == e.currentTarget) {
          btn.classList.contains('sound-on')
            ? btn.innerHTML = 'Sound off'
            : btn.innerHTML = 'Sound on'
        }
      })
    }
  }

  customElements.define('video-section', VideoSection);
}
